import React from 'react';
import { css } from 'emotion';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface SketchMetadataViewProps {
  className: string;
  metadata?: {
    original?: string;
    large?: string;
    thumbnail?: string;
  } | null;
}

const SketchMetadataView: React.FC<SketchMetadataViewProps> = ({ className, metadata }) => {
  const renderDownloadLinks = () => {
    if (metadata == null) {
      return null;
    }

    return (
      <div className={css(styles.block)}>
        <h1 className={css(styles.header)}>Download</h1>
        <div className={css(styles.fields)}>
          <div>
            <div className={css(styles.downloadLinkContainer)}>
              <a
                href={metadata.original}
                target="_blank"
                rel="noopener noreferrer"
                className={css(styles.downloadLink)}
              >
                Original
              </a>
            </div>
            <div className={css(styles.downloadLinkContainer)}>
              <a
                href={metadata.large}
                target="_blank"
                rel="noopener noreferrer"
                className={css(styles.downloadLink)}
              >
                Large
              </a>
            </div>
            <div className={css(styles.downloadLinkContainer)}>
              <a
                href={metadata.thumbnail}
                target="_blank"
                rel="noopener noreferrer"
                className={css(styles.downloadLink)}
              >
                Thumbnail
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${className} ${css(styles.container)}`}>
      {renderDownloadLinks()}
    </div>
  );
};

const styles = cssInJS({
  container: {
    fontFamily: THEME.fontFamily,
    backgroundColor: '#fff',
    borderLeft: '1px solid #dbdbdb',
  },

  block: {
    padding: 20,
    borderBottom: '1px solid #dbdbdb',
    fontSize: 13,
  },

  header: {
    fontWeight: 'bold',
    marginBottom: 4,
    fontSize: '100%',
  },

  fields: {
    paddingTop: 8,
  },

  downloadLinkContainer: {
    marginBottom: 8,
  },

  downloadLink: {
    color: THEME.linkColor,
    textDecoration: 'none',
  },
}) as {
  container: string;
  block: string;
  header: string;
  fields: string;
  downloadLinkContainer: string;
  downloadLink: string;
};

export default SketchMetadataView;
